import {
  useMutation,
} from "react-query";
import { createAgreementNotifications } from "./api";


export function useCreateAgreementNotifications(options) {
  return useMutation((data) => createAgreementNotifications(data), options);
}
